export default (theme) => ({
    '& .ag-body-viewport .ag-center-cols-clipper .ag-center-cols-viewport .ag-center-cols-container .ag-row .ag-cell-inline-editing':
        {
            borderColor: theme.colors.actionMajor[500],
            borderWidth: '2px',
            width: '100%',
            height: '100%',
            padding: '0',
        },
    '& .ag-body-viewport .ag-center-cols-clipper .ag-center-cols-viewport .ag-center-cols-container .ag-row .ag-cell-inline-editing .ag-cell-edit-wrapper':
        {
            width: '100%',
            height: '100%',
        },
    '& .ag-body-viewport .ag-center-cols-clipper .ag-center-cols-viewport .ag-center-cols-container .ag-row .ag-cell-inline-editing .ag-cell-edit-wrapper .ag-cell-editor':
        {
            width: '100%',
            height: '100%',
        },
    '& .ag-body-viewport .ag-center-cols-clipper .ag-center-cols-viewport .ag-center-cols-container .ag-row .ag-cell-inline-editing .ag-cell-edit-wrapper .ag-cell-editor .ag-input-wrapper':
        {
            width: '100%',
            height: '100%',
        },
    '& .ag-body-viewport .ag-center-cols-clipper .ag-center-cols-viewport .ag-center-cols-container .ag-row .ag-cell-inline-editing .ag-cell-edit-wrapper .ag-cell-editor .ag-input-wrapper input':
        {
            width: '100%',
            height: '100%',
            border: 'none',
            padding: '0 20px',
        },
    '& .ag-header-viewport': {
        borderBottom: `1px solid ${theme.colors.grey[100]}`,
    },
    '& .ag-pinned-left-header': {
        borderBottom: `1px solid ${theme.colors.grey[100]}`,
    },
});
